import {
  createThemes,
  layoutLadderCssVariables,
  themeColorCssVariables,
  themeCssVariables,
} from '@icebreaker/ui';
import { adminBrand } from '../config/env';

/**
 * PANELİN TEMA KATMANI — yalnız MARKAYI bağlar.
 *
 * Token boru hattı kittedir (`packages/ui/src/theme-css.ts`); panel onu
 * KOPYALAMAZ, çağırır. Web tarafı da aynı fonksiyonları kullanır, yani bir
 * token eklendiğinde iki uygulama birlikte alır. Ray profili `admin`: panel
 * Revizyon 2 raylarını korur (1180, xxl'de `min(78vw, 1760)`); web'in yeni
 * görünüm rayı (1424, R turu 29.10.2026) panele geçmez.
 */
export const themes = createThemes(adminBrand);

/**
 * Değişkenler `<style>` ile belgeye basılır. Panelde SSR yoktur; FOUC engeli
 * `main.tsx` içinde ilk boyamadan önce `data-theme` yazılarak kurulur (inline
 * script YOK — CSP `script-src` gevşetilmez).
 */
export function ThemeStyle() {
  const css = [
    `:root{${themeCssVariables('light', adminBrand, 'admin')}}`,
    `[data-theme='dark']{${themeColorCssVariables('dark', adminBrand)}}`,
    layoutLadderCssVariables('admin'),
  ].join('\n');
  return <style>{css}</style>;
}
